import auditSlice from './audit/auditSlice';
import cardsSlice from './cards/cardsSlice';
import contractsSlice from './contracts/contractsSlice';
import customersSlice from './customers/customersSlice';
import destPointSlice from './destPoint/destPointSlice';
import driversSlice from './drivers/driversSlice';
import identitySlice from './identity/identitySlice';
import licensesSlice from './licenses/licensesSlice';
import productsSlice from './products/productsSlice';
import resultsSlice from './results/resultsSlice';
import settingsSlice from './settings/settingsSlice';
import spySlice from './spy/spySlice';
import vehiclesSlice from './vehicles/vehiclesSlice';
import weightingsSlice from './weightings/weightingsSlice';
import usersSlice from './users/usersSlice';
import accessGroupsSlice from './accessGroups/accessGroupsSlice';

const reduxSlicesList = {
 results: resultsSlice.actions,
 customers: customersSlice.actions,
 drivers: driversSlice.actions,
 vehicles: vehiclesSlice.actions,
 weightings: weightingsSlice.actions,
 products: productsSlice.actions,
 'products/groups': productsSlice.actions,
 contracts: contractsSlice.actions,
 'contracts/details': contractsSlice.actions,
 spy: spySlice.actions,
 destPoint: destPointSlice.actions,
 'destPoint/details': destPointSlice.actions,
 cards: cardsSlice.actions,
 settings: settingsSlice.actions,
 identity: identitySlice.actions,
 licenses: licensesSlice.actions,
 users: usersSlice.actions,
 accessGroups: accessGroupsSlice.actions,
 audit: auditSlice.actions,
};

export default reduxSlicesList;

